// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"270":"67a9ec2a","344":"44fac368","412":"a623b430","453":"da5cd0f7"}[chunkId] + ".chunk.js";
};